import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { CurrenciesDSVType } from "../../constants/currenciesDSV"

/**
 * Args for currency conversion
 * @param fromCurrency - The currency to convert from
 * @param toCurrency - The currency to convert to
 * @param amount - The amount to convert
 */
@Serializable
export class CurrencyConversionArgs {
  fromCurrency: CurrenciesDSVType | "" = ""
  toCurrency: CurrenciesDSVType | "" = ""
  amount: number = 0

  constructor(
    data: {
      fromCurrency: CurrenciesDSVType | ""
      toCurrency: CurrenciesDSVType | ""
      amount: number
    } | null = null,
  ) {
    if (data) {
      this.fromCurrency = data.fromCurrency
      this.toCurrency = data.toCurrency
      this.amount = data.amount
    }
  }
}
